// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"328":"admin","388":"dev"}[chunkId] + "." + {"328":"79d2d6ae","388":"b5faaf7c"}[chunkId] + ".js";
};